/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllHistory, } from "../../Redux/CommonSlice";
import "react-quill/dist/quill.snow.css";
import { BiSolidLabel } from "react-icons/bi";
import { MdCameraRoll, MdEmail, MdOutlineKeyboardBackspace, MdOutlineLinkOff, } from "react-icons/md";
import { addORUpdateLeadMaster, archiveLeadData, editLeadmaster } from '../../Redux/LeadsSlice';
import toast from 'react-hot-toast';
import moment from 'moment/moment';
import Footer from '../Common/Footer';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { FaAngleDown, FaAngleUp, FaPlus, FaRegFlag } from 'react-icons/fa6';
import { IoBusinessSharp, IoLocationSharp } from 'react-icons/io5';
import AddDeals from '../Deals/AddDeals';
import Loading from '../Common/Loading';
import { fetchApiData } from "../../Redux/organizationSlice";
import { getAllPerson } from "../../Redux/PersonSlice";
import { FiCheckSquare, FiArchive, FiInfo, FiUser, FiMail } from "react-icons/fi";
import AddEditPerson from "../Contacts/AddEditPerson";
import AddEditOrganizations from "../Contacts/AddEditOrganizations";
import sweetAlert from "../Common/sweetAlert";
import LinkLeads from "./LinkLeads";
import getUserDetail, { FormatDateMoment } from "../Common/defaultValue";
import HistoryView from "../Common/HistoryView";
import { FiPhone } from "react-icons/fi";

const InfoDetailsLeads = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const store = useSelector((state) => state.root.common);
  const getHistory = useSelector((state) => state.root.leads);
  const organizationstore = useSelector((state) => state.root.organization);
  const Peoplestore = useSelector((state) => state.root.Person);
  const userDetails = getUserDetail();

  const [activeSidebarTab, setActiveSidebarTab] = useState("details");
  const [loading, setLoading] = useState(true);
  const [loadFist, setLoadFist] = useState(true);
  const [leadData, setleaadData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [openSelect, setopenSelect] = useState(false);
  const [link, setlink] = useState('');
  const [linkOrg, setlinkOrg] = useState('');
  const [openOrganization, setOpenOrganization] = useState(false);
  const [OpenPerson, setOpenPerson] = useState(false);
  const [Error, setError] = useState('');

  const toggleSidebarSection = (section) => {
    setActiveSidebarTab((current) => (current === section ? "" : section));
  };

  useEffect(() => {
    const query = { type: "lead", id: id };
    if (loadFist) {
      setLoading(true);
      EditLead(id);
      dispatch(getAllPerson({}));
      dispatch(fetchApiData({}));
      dispatch(getAllHistory(query))
        .then((res) => {
          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);
          return () => clearTimeout(timer);
        });
      setLoadFist(false);
    }
  }, [loadFist, store, dispatch, id]);

  const toggleModalData = () => { setLoadFist(true); setOpenOrganization(!openOrganization); };

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const togglePerson = () => {
    setOpenPerson(!OpenPerson);
  };

  const toggleSelect = (item) => {
    setopenSelect(!openSelect);
    setlink(item);
    setlinkOrg('');
    setError('');
  };

  const EditLead = async (id) => {
    try {
      const res = await dispatch(editLeadmaster(id));
      if (res.payload.status === true) {
        setleaadData(res?.payload?.data);
      }
    } catch (error) {
      console.log('error :>> ', error);
    }
  };

  const archiveLead = (item) => {
    const payload = {
      LeadID: id,
      IsArchived: item,
    };
    dispatch(archiveLeadData(payload)).then((res) => {
      setLoadFist(true);
      navigate("/LeadInbox");
    });
  };

  const updateLead = (linkData) => {
    if (!linkOrg) {
      setError(`The ${link} name is Required`);
      return;
    }
    const payload = {
      leadID: leadData && leadData.leadID ? leadData.leadID : 0,
      peopleID: link && link === "Person" ? (linkData ? linkData.value : leadData.peopleID) : leadData?.peopleID,
      organizationID: link && link === "Organization" ? (linkData ? linkData.value : leadData.organizationID) : leadData.organizationID,
      title: leadData?.title,
      value: leadData?.value,
      currencyID: leadData?.currencyID,
      labelID: leadData?.labelID,
      ownerID: leadData?.ownerID,
      ExpectedCloseDate: leadData?.expectedCloseDate,
      visibleID: leadData?.visibleID,
      sourceType: "Manually created",
      leadPhoneDetails: leadData?.leadPhoneDetails,
      leadEmailDetails: leadData?.leadEmailDetails
    };

    dispatch(addORUpdateLeadMaster(payload)).then((res) => {
      toast.remove();
      if (res.payload.status === true) {
        setLoadFist(true);
        toggleSelect();
        toast.success(`${link} linked Successfully!`);
      }
    });
  };

  const UnlinkedData = async (id, type) => {
    try {
      const result = await sweetAlert.confirm(`Are you sure you want to unlink this ${type} from this Lead?`, null, 'unlink');

      const Payload = {
        ...leadData,
        organizationID: type === 'Organization' ? id : leadData?.organizationID,
        peopleID: type === 'Person' ? id : leadData?.peopleID
      };

      if (result?.isConfirmed) {
        dispatch(addORUpdateLeadMaster(Payload)).then((res) => {
          toast.remove();
          if (res.payload.status === true) {
            setLoadFist(true);
          }
        }).catch((error) => console.log('error :>> ', error));
      }

    } catch (error) {
      console.error("Error:", error);
      sweetAlert.error("An error occurred");
    }
  };

  return (
    <>
      <div className="flex flex-1">
        <div className="page-wrapper relative ml-auto w-[calc(100%-326px)] px-4 pt-[54px] duration-300">
          <div className="xl:w-full mb-4">
            <div className="flex items-center gap-2 py-3">
              <button
                onClick={() => navigate("/LeadInbox")}
                className="p-1.5 text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-white transition-colors"
              >
                <MdOutlineKeyboardBackspace size={22} />
              </button>
              <h1 className="text-lg font-bold text-slate-900 dark:text-white tracking-tight">
                Lead Details
              </h1>
            </div>
          </div>
          <div className="xl:w-full min-h-[calc(100vh-138px)] relative pb-14">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <div className="bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-800 shadow-sm rounded-2xl p-5 mb-1 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-full bg-emerald-50 dark:bg-emerald-950/40 flex items-center justify-center text-emerald-600 dark:text-emerald-450 font-bold text-lg border border-emerald-100 dark:border-emerald-900/30">
                      {leadData?.title ? leadData.title.charAt(0).toUpperCase() : "T"}
                    </div>
                    <div>
                      <div className="flex items-center gap-2">
                        <h2 className="text-base font-extrabold text-slate-850 dark:text-white capitalize">{leadData?.title || "Testing"}</h2>
                        <span className="bg-blue-50 text-blue-600 dark:bg-blue-950/40 dark:text-blue-400 text-[10px] font-bold px-2 py-0.5 rounded uppercase">New</span>
                      </div>
                      <div className="flex flex-wrap items-center gap-x-4 gap-y-1.5 mt-1.5 text-xs text-slate-400 font-medium">
                        <div className="flex flex-col items-center gap-1.5">
                          <span className="text-slate-400">Lead Source</span>
                          <span className="text-slate-700 dark:text-slate-250 font-bold">{leadData?.sourceType || "Website"}</span>
                        </div>

                        <span className="text-slate-200 dark:text-slate-800">|</span>
                        {/* <div className="flex items-center gap-1.5">
                          <span className="text-slate-400">Score</span>
                          <span className="text-slate-700 dark:text-slate-250 font-bold">78</span>
                        </div>
                        <span className="text-slate-200 dark:text-slate-800">|</span> */}
                        <div className="flex flex-col items-center gap-1.5">
                          <span className="text-slate-400">Created On</span>
                          <span className="text-slate-700 dark:text-slate-250 font-bold">{moment(leadData?.createdDate).format("MMMM Do YYYY, h:mm a")}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    {/* <button className="flex items-center gap-1.5 px-3.5 py-2 text-xs font-bold text-slate-600 dark:text-slate-355 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl hover:bg-slate-50 dark:hover:bg-slate-850 shadow-sm transition-all duration-200">
                      <FiEdit size={13} /> Edit
                    </button> */}
                    <button
                      onClick={() => setShowModal(true)}
                      className="flex items-center gap-1.5 px-4 py-2 text-xs font-bold text-white bg-blue-600 hover:bg-blue-700 rounded-xl shadow-md shadow-blue-100 dark:shadow-none hover:shadow-lg transition-all duration-200"
                    >
                      <FiCheckSquare size={13} /> Convert to Deal
                    </button>
                    {getHistory?.leadsEdit?.isArchived ? (
                      <button
                        onClick={() => archiveLead(false)}
                        className="flex items-center gap-1.5 px-3.5 py-2 text-xs font-bold text-slate-600 dark:text-slate-355 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl hover:bg-slate-50 dark:hover:bg-slate-850 shadow-sm transition-all duration-200"
                      >
                        UnArchive
                      </button>
                    ) : (
                      <button
                        onClick={() => archiveLead(true)}
                        className="flex items-center gap-1.5 px-3.5 py-2 text-xs font-bold text-slate-650 dark:text-slate-355 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl hover:bg-slate-50 dark:hover:bg-slate-850 shadow-sm transition-all duration-200"
                      >
                        <FiArchive size={13} /> Archive
                      </button>
                    )}
                    {/* <button className="p-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl hover:bg-slate-50 dark:hover:bg-slate-850 shadow-sm transition-all duration-200">
                      <FiMoreHorizontal size={14} />
                    </button> */}
                  </div>
                </div>
              </div>

              <div className="col-span-12">
                {loading ? (
                  <div className="flex justify-center items-center h-60">
                    <Loading />
                  </div>
                ) : (
                  <div className="grid grid-cols-12 gap-6">
                    <div className="col-span-12 lg:col-span-3 flex flex-col gap-4">
                      <div className="bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-800 shadow-sm rounded-2xl p-3">
                        <div className="flex flex-col gap-2">
                          <section className="overflow-hidden rounded-2xl border border-slate-200/80 dark:border-slate-800 shadow-sm">
                            <button
                              type="button"
                              onClick={() => toggleSidebarSection("details")}
                              className="flex w-full items-center justify-between gap-3 bg-slate-50/90 dark:bg-slate-950/40 px-4 py-3 text-left transition-colors hover:bg-slate-100/80 dark:hover:bg-slate-800/70"
                            >
                              <span className="flex items-center gap-3 text-sm font-medium text-slate-700 dark:text-slate-200">
                                <FiInfo className="h-4 w-4 text-slate-400" />
                                Details
                              </span>
                              {activeSidebarTab === "details" ? <FaAngleUp className="text-slate-400" /> : <FaAngleDown className="text-slate-400" />}
                            </button>
                            {activeSidebarTab === "details" && (
                              <div className="border-t border-slate-200/80 dark:border-slate-800 bg-white dark:bg-slate-900">
                                <div className="grid gap-0">
                                  <div className="flex items-center gap-3 border-b border-slate-200/70 dark:border-slate-800 px-4 py-3">
                                    <MdCameraRoll className="text-slate-500 shrink-0" />
                                    <span className="text-sm font-semibold text-slate-700 dark:text-slate-200">Lead</span>
                                  </div>
                                  <div className="flex items-center gap-3 border-b border-slate-200/70 dark:border-slate-800 px-4 py-3">
                                    <BiSolidLabel className="text-slate-500 shrink-0" />
                                    <span
                                      className="text-[11px] font-bold px-2.5 py-1 rounded-md uppercase tracking-wide inline-flex w-max"
                                      style={{
                                        backgroundColor: leadData?.color ? `${leadData.color}20` : '#dbeafe',
                                        color: leadData?.color || '#1d4ed8',
                                        border: `1px solid ${leadData?.color || '#93c5fd'}40`
                                      }}
                                    >
                                      {leadData?.labelName || 'No Label'}
                                    </span>
                                  </div>
                                  <div className="flex items-center gap-3 border-b border-slate-200/70 dark:border-slate-800 px-4 py-3">
                                    <span className="text-slate-500 font-bold shrink-0">₹</span>
                                    <span className="text-sm font-semibold text-slate-700 dark:text-slate-200">
                                      {leadData?.currencyName || leadData?.currencyCode || 'INR'} {Number(leadData?.value || 0).toLocaleString('en-IN')}
                                    </span>
                                  </div>
                                  <div className="flex items-center gap-3 border-b border-slate-200/70 dark:border-slate-800 px-4 py-3">
                                    <FaRegFlag className="text-slate-500 shrink-0" />
                                    <span className="text-sm font-semibold text-slate-700 dark:text-slate-200">
                                      {FormatDateMoment(leadData?.expectedCloseDate) || 'Not Scheduled'}
                                    </span>
                                  </div>
                                  <div className="flex items-center gap-3 border-b border-slate-200/70 dark:border-slate-800 px-4 py-3">
                                    <MdOutlineKeyboardBackspace className="text-slate-500 shrink-0 rotate-180" />
                                    <span className="text-sm font-semibold text-slate-700 dark:text-slate-200">
                                      {leadData?.sourceType || 'Manual'}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                          </section>

                          <section className="overflow-hidden rounded-2xl border border-slate-200/80 dark:border-slate-800 shadow-sm">
                            <button
                              type="button"
                              onClick={() => toggleSidebarSection("person")}
                              className="flex w-full items-center justify-between gap-3 bg-slate-50/90 dark:bg-slate-950/40 px-4 py-3 text-left transition-colors hover:bg-slate-100/80 dark:hover:bg-slate-800/70"
                            >
                              <span className="flex items-center gap-3 text-sm font-medium text-slate-700 dark:text-slate-200">
                                <FiUser className="h-4 w-4 text-slate-400" />
                                Person
                              </span>
                              {activeSidebarTab === "person" ? <FaAngleUp className="text-slate-400" /> : <FaAngleDown className="text-slate-400" />}
                            </button>

                            {activeSidebarTab === "person" && (
                              <div className="border-t border-slate-200/80 dark:border-slate-800 bg-white dark:bg-slate-900">
                                {leadData?.person === null ? (
                                  <p className="text-slate-400 dark:text-slate-500 text-center text-xs font-medium py-6 px-4">
                                    No Person linked to this Lead
                                  </p>
                                ) : (
                                  <div className="grid gap-0">
                                    <div className="flex items-center gap-3 border-b border-slate-200/70 dark:border-slate-800 px-4 py-3">
                                      <FiUser className="text-slate-500 shrink-0" />
                                      <Link
                                        to={`/detailsPeople/${leadData?.person?.personMasterID}`}
                                        className="text-sm font-semibold text-indigo-600 dark:text-indigo-400 hover:underline truncate"
                                      >
                                        {leadData?.person?.name}
                                      </Link>
                                    </div>
                                    <div className="flex items-center gap-3 border-b border-slate-200/70 dark:border-slate-800 px-4 py-3">
                                      <BiSolidLabel className="text-slate-500 shrink-0" />
                                      <span
                                        className="text-[11px] font-bold px-2.5 py-1 uppercase rounded-md inline-flex w-max shadow-sm"
                                        style={{
                                          backgroundColor: leadData?.person?.color ? `${leadData.person.color}20` : '#dbeafe',
                                          color: leadData?.person?.color || '#1d4ed8',
                                          border: `1px solid ${leadData?.person?.color || '#93c5fd'}40`
                                        }}
                                      >
                                        {leadData?.person?.labelName || 'No Label'}
                                      </span>
                                    </div>
                                    <div className="flex items-start gap-3 border-b border-slate-200/70 dark:border-slate-800 px-4 py-3">
                                      <FiPhone className="text-slate-500 shrink-0 mt-0.5" />
                                      <div className="flex flex-col gap-1">
                                        {leadData?.person?.personPhoneDetails?.length > 0 ? (
                                          leadData.person.personPhoneDetails.map((item, index) => (
                                            <div key={index} className="flex items-center gap-2 text-xs">
                                              <span className="text-slate-700 dark:text-slate-200 font-semibold">{item?.phoneNumber}</span>
                                              {item?.phoneType && <span className="text-slate-400 text-[10px]">({item.phoneType})</span>}
                                            </div>
                                          ))
                                        ) : (
                                          <span className="text-xs text-slate-400">Not set</span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="flex items-start gap-3 border-b border-slate-200/70 dark:border-slate-800 px-4 py-3">
                                      <MdEmail className="text-slate-500 shrink-0 mt-0.5" />
                                      <div className="flex flex-col gap-1">
                                        {leadData?.person?.personEmailDetails?.length > 0 ? (
                                          leadData.person.personEmailDetails.map((item, index) => (
                                            <div key={index} className="flex items-center gap-2 text-xs">
                                              <a
                                                href={`mailto:${item?.email}`}
                                                className="text-indigo-600 dark:text-indigo-400 font-semibold hover:underline truncate"
                                              >
                                                {item?.email}
                                              </a>
                                              {item?.emailType && <span className="text-slate-400 text-[10px]">({item.emailType})</span>}
                                            </div>
                                          ))
                                        ) : (
                                          <span className="text-xs text-slate-400">Not set</span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="flex items-center justify-end gap-2 px-4 py-3">
                                      <button
                                        type="button"
                                        onClick={() => toggleSelect("Person")}
                                        className="flex items-center gap-1 px-3 py-1.5 text-[10px] font-bold text-indigo-600 bg-indigo-50 hover:bg-indigo-100 dark:bg-slate-800 dark:text-indigo-400 dark:hover:bg-slate-700 rounded-full transition-colors shadow-sm"
                                      >
                                        <FaPlus className="w-2.5 h-2.5" />
                                        <span>Link Person</span>
                                      </button>
                                      {leadData?.person !== null && (
                                        <button
                                          type="button"
                                          onClick={() => UnlinkedData(0, "Person")}
                                          className="p-2 text-slate-500 hover:text-red-600 hover:bg-red-50 dark:text-slate-400 dark:hover:text-red-400 dark:hover:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-full transition-colors shadow-sm"
                                        >
                                          <MdOutlineLinkOff size={14} />
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </section>


                          <section className="overflow-hidden rounded-2xl border border-slate-200/80 dark:border-slate-800 shadow-sm">
                            <button
                              type="button"
                              onClick={() => toggleSidebarSection("organization")}
                              className="flex w-full items-center justify-between gap-3 bg-slate-50/90 dark:bg-slate-950/40 px-4 py-3 text-left transition-colors hover:bg-slate-100/80 dark:hover:bg-slate-800/70"
                            >
                              <span className="flex items-center gap-3 text-sm font-medium text-slate-700 dark:text-slate-200">
                                <IoBusinessSharp className="h-4 w-4 text-slate-400" />
                                Organizations
                              </span>
                              {activeSidebarTab === "organization" ? <FaAngleUp className="text-slate-400" /> : <FaAngleDown className="text-slate-400" />}
                            </button>
                            {activeSidebarTab === "organization" && (
                              <div className="border-t border-slate-200/80 dark:border-slate-800 bg-white dark:bg-slate-900">
                                {leadData?.organization === null ? (
                                  <p className="text-slate-400 dark:text-slate-500 text-center text-xs font-medium py-6 px-4">
                                    No organization linked to this Lead
                                  </p>
                                ) : (
                                  <div className="grid gap-0">
                                    <div className="flex items-center gap-3 border-b border-slate-200/70 dark:border-slate-800 px-4 py-3">
                                      <IoBusinessSharp className="text-slate-500 shrink-0" />
                                      <Link
                                        to={`/detailsOrganization/${leadData?.organization?.organizationID}`}
                                        className="text-sm font-semibold text-indigo-600 dark:text-indigo-400 hover:underline truncate"
                                      >
                                        {leadData?.organization?.organizationName}
                                      </Link>
                                    </div>
                                    <div className="flex items-center gap-3 border-b border-slate-200/70 dark:border-slate-800 px-4 py-3">
                                      <BiSolidLabel className="text-slate-500 shrink-0" />
                                      <span
                                        className="text-[11px] font-semibold px-2.5 py-1 uppercase rounded-md inline-flex w-max shadow-sm"
                                        style={{
                                          backgroundColor: leadData?.organization?.color ? `${leadData.organization.color}20` : '#dbeafe',
                                          color: leadData?.organization?.color || '#1d4ed8',
                                          border: `1px solid ${leadData?.organization?.color || '#93c5fd'}40`
                                        }}
                                      >
                                        {leadData?.organization?.labelName || 'No Label'}
                                      </span>
                                    </div>
                                    <div className="flex items-start gap-3 border-b border-slate-200/70 dark:border-slate-800 px-4 py-3">
                                      <IoLocationSharp className="text-slate-500 shrink-0 mt-0.5" />
                                      <p className="text-sm font-semibold text-slate-700 dark:text-slate-200 leading-5">
                                        {leadData?.organization?.address || 'Not set'}
                                      </p>
                                    </div>
                                    <div className="flex items-center justify-end gap-2 px-4 py-3">
                                      <button
                                        type="button"
                                        className="flex items-center gap-1 px-3 py-1.5 text-[10px] font-bold text-indigo-600 bg-indigo-50 hover:bg-indigo-100 dark:bg-slate-800 dark:text-indigo-400 dark:hover:bg-slate-700 rounded-full transition-colors shadow-sm"
                                        onClick={() => toggleSelect("Organization")}
                                      >
                                        <FaPlus className="w-2.5 h-2.5" />
                                        <span>Link an Organization</span>
                                      </button>
                                      {leadData?.organization !== null && (
                                        <button
                                          type="button"
                                          className="p-2 text-slate-500 hover:text-red-600 hover:bg-red-50 dark:text-slate-400 dark:hover:text-red-400 dark:hover:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-full transition-colors shadow-sm"
                                          onClick={() => UnlinkedData(0, "Organization")}
                                        >
                                          <MdOutlineLinkOff size={14} />
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </section>

                          <section className="overflow-hidden rounded-2xl border border-slate-200/80 dark:border-slate-800 shadow-sm">
                            <button
                              type="button"
                              onClick={() => toggleSidebarSection("bcc")}
                              className="flex w-full items-center justify-between gap-3 bg-slate-50/90 dark:bg-slate-950/40 px-4 py-3 text-left transition-colors hover:bg-slate-100/80 dark:hover:bg-slate-800/70"
                            >
                              <span className="flex items-center gap-3 text-sm font-medium text-slate-700 dark:text-slate-200">
                                <FiMail className="h-4 w-4 text-slate-400" />
                                Smart Bcc
                              </span>
                              {activeSidebarTab === "bcc" ? <FaAngleUp className="text-slate-400" /> : <FaAngleDown className="text-slate-400" />}
                            </button>
                            {activeSidebarTab === "bcc" && (
                              <div className="border-t border-slate-200/80 dark:border-slate-800 bg-white dark:bg-slate-900 px-4 py-4">
                                <div className="flex flex-col gap-2">
                                  <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider">Universal Email Address</p>
                                  <input
                                    type="text"
                                    className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-600 outline-none dark:border-slate-800 dark:bg-slate-950 dark:text-slate-300"
                                    value={userDetails?.emailID || ""}
                                    disabled
                                  />
                                </div>
                              </div>
                            )}
                          </section>
                        </div>
                      </div>

                      {/* Dates Display box */}
                      <div className="bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-800 rounded-2xl p-4 shadow-sm flex flex-col gap-2.5">
                        <div className="flex flex-col gap-0.5">
                          <span className="text-[10px] text-slate-400 font-bold uppercase tracking-wider">Updated</span>
                          <span className="text-xs text-slate-700 dark:text-slate-200 font-bold mt-0.5">
                            {moment(leadData?.updatedDate).format("MMMM Do YYYY, h:mm a")}
                          </span>
                        </div>
                        <div className="flex flex-col gap-0.5 mt-1 border-t border-slate-100 dark:border-slate-855 pt-2">
                          <span className="text-[10px] text-slate-400 font-bold uppercase tracking-wider">Created</span>
                          <span className="text-xs text-slate-700 dark:text-slate-200 font-bold mt-0.5">
                            {moment(leadData?.createdDate).format("MMMM Do YYYY, h:mm a")}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-span-12 lg:col-span-9">
                      <HistoryView Data={leadData} setLoadFirst={setLoadFist} getAllVisible={store} id={id} identityName='lead' showTabsOnly={true} />
                    </div>
                    <div className="col-span-12">
                      <HistoryView Data={leadData} setLoadFirst={setLoadFist} getAllVisible={store} id={id} identityName='lead' showHistoryOnly={true} />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {openSelect && (
        <LinkLeads
          link={link}
          toggleSelect={toggleSelect}
          linkOrg={linkOrg}
          Peoplestore={Peoplestore}
          setlinkOrg={setlinkOrg}
          organizationstore={organizationstore}
          updateLead={updateLead}
          Error={Error}
          Data={leadData}
        />
      )}

      {OpenPerson && <AddEditPerson togglemodel={togglePerson} setLoadFirst={setLoadFist} />}

      {openOrganization && (<AddEditOrganizations toggleModalOrganization={toggleModalData} setLoadFist={setLoadFist} />)}

      {showModal && <AddDeals toggleModal={toggleModal} leadData={leadData} setloadFrist={setLoadFist} />}

    </>
  );
};

export default InfoDetailsLeads;
